<template>
  <b-modal
    id="item-accounts-modal"
    ref="itemAccountsModal"
    header-class="anchor-modal"
    size="xl"
    hide-footer
    scrollable
  >
    <plaid-item
      :record="item"
      :accounts="accounts"
      :asset-report-id="assetReportId"
      @item-deleted="(response) => $emit('item-deleted', response)"
    />
  </b-modal>
</template>

<script>
import PlaidItem from './PlaidItem';

export default {
  name: 'AccountsModal',
  data() {
    return {
      item: Object,
      accounts: Object,
      assetReportId: String,
    };
  },
  components: {
    PlaidItem,
  },
  methods: {
    show(assetReportId, item, accounts) {
      this.assetReportId = assetReportId;
      this.item = item;
      this.accounts = accounts;
      this.$refs.itemAccountsModal.show();
    },
    hide() {
      this.$refs.itemAccountsModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plaid/AccountsModal.vue